import AnimatedImageLoad from "./animated-image-load";
import AnimatedNumber from "./animated-number";
import AnimatedRing from "./animated-ring";
import CenterSelected from "./center-selected";
import DeckChart from "./deck-chart";
import DocsScrollSpy from "./docs-scroll-spy";
import DonutChart from "./donut-chart";
import DropdownMenu from "./dropdown-menu";
import InputClearButton from "./input-clear-button";
import MobileNav from "./mobile-nav";
import RedispatchEvents from "./redispatch-events";
import ReportDeck from "./report-deck";
import ReportFundField from "./report-fund-field";
import ReportFundScatter from "./report-fund-scatter";
import ReportHighlights from "./report-highlights";
import ReportNumber from "./report-number";
import ReportReveal from "./report-reveal";
import SearchDialog from "./search-dialog";
import SignalPriceChart from "./signal-price-chart";
import SortableTable from "./sortable-table";
import Tooltip from "./tooltip";

export const hooks = {
  AnimatedImageLoad,
  AnimatedNumber,
  AnimatedRing,
  CenterSelected,
  DeckChart,
  DocsScrollSpy,
  DonutChart,
  DropdownMenu,
  InputClearButton,
  MobileNav,
  RedispatchEvents,
  ReportDeck,
  ReportFundField,
  ReportFundScatter,
  ReportHighlights,
  ReportNumber,
  ReportReveal,
  SearchDialog,
  SignalPriceChart,
  SortableTable,
  Tooltip,
};
